import React from 'react';
import { Input, Modal, Table, message, Button } from 'antd';
import { NotificationOutlined } from '@ant-design/icons'
import { columns } from './columns';
import axios from 'axios';
import _ from 'lodash';

const { TextArea } = Input;

const UserTable = ({ data }) => {
  const inputRef = React.useRef(null);
  const [col, setCol] = React.useState()
  const [selectedUserIds, setSelectedUserIds] = React.useState([])
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let newCol = columns

    _.last(newCol).title = () => <NotificationOutlined onClick={() => setOpen(true)} />

    setCol(newCol)
  }, []);

  const sendLineMsg = () => {
    const user_ids = selectedUserIds
    const msg = inputRef.current.resizableTextArea.textArea.value

    setLoading(true);
    axios.post('/admins/users/line_msg', {
      user_ids,
      msg
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      message.success('success')
      setOpen(false)
    }).catch((error) => {
      message.error('error')
    }).finally(() => {
      setLoading(false);
    })
  }

  const sendLineMsgAll = () => {
    const msg = inputRef.current.resizableTextArea.textArea.value
    setLoading(true);
    axios.post(`/admins/users/line_msg${window.location.search}`, {
      user_ids: 'send_all',
      msg
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      message.success('success')
      setOpen(false)
    }).catch((error) => {
      message.error('error')
    }).finally(() => {
      setLoading(false);
    })
  }

  return (
    <>
      <Modal
        title={`ส่ง Line ไปที่เจ้าของ User ID: ${selectedUserIds.join(', ')}`}
        open={open}
        onCancel={() => setOpen(false)}
        confirmLoading={loading}
        footer={[
          <Button key='cancel' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button key='ok' type="primary" onClick={sendLineMsg} disabled={_.isEmpty(selectedUserIds)} >
            Send Selected
          </Button>,
          <Button key="send_all" type="danger" onClick={sendLineMsgAll}>
            Send All
          </Button>,
        ]}
      >
        <TextArea ref={inputRef} />
      </Modal>
      <Table
        rowSelection={{
          type: 'checkbox',
          onChange: setSelectedUserIds
        }}
        columns={col}
        dataSource={data}
        pagination={false}
      />
    </>

  );
}

export default UserTable;
